import type { ServiceSignInResult } from '../../types';
import type { IdentityProvider } from '../identity-provider';
import type { HttpClient } from '../client-app/index';
import { tokenExchange, tokenExchangeWithPhone } from './token-exchange';
import type { AuthLogger } from '../../shared/auth-logger';
import { SessionStep } from '../../constants';

export async function cognitoRefreshSession(
  idp: IdentityProvider,
  http: HttpClient,
  logger?: AuthLogger,
): Promise<ServiceSignInResult | null> {
  let idToken: string;
  try {
    logger?.log(SessionStep.Refresh);
    idToken = await idp.getIdToken();
  } catch {
    logger?.log(SessionStep.RefreshNoSession);
    return null;
  }

  const result = await tokenExchange(http, idToken, undefined, logger);
  if (result.needsPhone) return { needsPhone: true };
  if (!result.user) throw new Error('invalid token exchange response');
  return { user: result.user, needsPhone: false };
}

export async function cognitoSignOut(
  idp: IdentityProvider,
  http: HttpClient,
  logger?: AuthLogger,
  redirectUrl?: string,
): Promise<void> {
  logger?.log(SessionStep.SignOut);
  try {
    await idp.signOut(redirectUrl);
  } finally {
    try {
      await http.request('/services/api/v3/users/logout', 'DELETE');
    } catch (err) {
      logger?.log(SessionStep.SignOutError, { error: err instanceof Error ? err.message : String(err) });
    }
  }
}

export async function cognitoSubmitPhone(
  idp: IdentityProvider,
  http: HttpClient,
  phone: string,
  profile?: { firstName: string; lastName: string } | null,
  logger?: AuthLogger,
): Promise<ServiceSignInResult> {
  logger?.log(SessionStep.SubmitPhone);
  const idToken = await idp.getIdToken();
  const user = await tokenExchangeWithPhone(http, idToken, phone, profile, logger);
  return { user };
}
